import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { PreviewInvoiceByJobId } from "../../api/job/index";
import LoadingComponent from "common/components/loader";

const InvoicePreviewPage: React.FC = () => {
  const title = "Invoice Preview";
  const pageTitle = "Invoice Preview";

  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [htmlContent, setHtmlContent] = useState("");
  useEffect(() => {
    const fetchData = async () => {
      await loadInvoiceContent(id ?? "");
    };

    fetchData();
  }, []);
  const loadInvoiceContent = async (id: string) => {
    //param?: TenantSearchParam
    setLoading(true);

    const res = await PreviewInvoiceByJobId(id);
    if (!(res?.status?.isError ?? false) && res?.data) {
      setHtmlContent(res?.data?.htmlContent ?? "");
    } else {
      setHtmlContent("");
    }
    setLoading(false);
  };
  return (
    <div className="w-full">
      {loading ? <LoadingComponent></LoadingComponent> : <div dangerouslySetInnerHTML={{ __html: htmlContent }} />}
    </div>
  );
};

export default InvoicePreviewPage;
